import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { deleteAppComponentQuery } from '../apis';
import { toast } from 'react-toastify';

const useDeleteAppComponent = () => {
  const mutationAction = useMutation({
    mutationFn: deleteAppComponentQuery,
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error delete app component:', error);
    },
  });

  return mutationAction;
};

export default useDeleteAppComponent;
